import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
// import moment from 'moment';

const styles = StyleSheet.create({
  invoice__date: {
    marginTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  section__first: {
    alignItems: 'flex-start',
  },

  gray__text__heading: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginBottom: 7,
    marginTop: 12,
  },

  gray__small__text: {
    lineHeight: 2,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
    maxWidth: '160px',
    wordWrap: 'break-word',
  },
  font__bold: {
    fontWeight: 'bold',
  },
});

export default function Information({ data }) {
  const {
    customer = '',
    vehicle = '',
    visitType = '',
    mileageIn = '',
    mileageInType = '',
    extrasWithVehicle = '',
    serviceAdvisor = '',
  } = data || '';
  const { name = '', phone = '', email = '', address = '' } = customer || '';
  const {
    vehicleMake = '',
    vehicleModel = '',
    modelYear = '',
    licensePlate = '',
    vin = '',
    displacement = '',
    engineDisplacementType = '',
    vehicleType = '',
  } = vehicle || '';

  return (
    <>
      <View style={styles.invoice__date}>
        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Customer Info:</Text>
          <Text style={styles.gray__small__text}>{name}</Text>
          <Text style={styles.gray__small__text}>
            {phone?.toLocaleString()}
          </Text>
          <Text style={styles.gray__small__text}>{email}</Text>
          <Text style={styles.gray__small__text}>{address}</Text>
        </View>
        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Vehicle Info:</Text>
          <Text style={styles.gray__small__text}>
            {modelYear} {vehicleMake} {vehicleModel}
          </Text>
          <Text style={styles.gray__small__text}>
            <span style={styles.font__bold}>License Plate:</span>
            {licensePlate}
          </Text>
          <Text style={styles.gray__small__text}>VIN: {vin}</Text>
          <Text style={styles.gray__small__text}>
            {displacement} {engineDisplacementType}
          </Text>
          <Text style={styles.gray__small__text}>{vehicleType}</Text>
        </View>
        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Visit Type:</Text>
          <Text style={styles.gray__small__text}>
            {visitType === 'dropOff' ? 'Drop Off' : 'Stay With Vehicle'}
          </Text>
          <View style={styles.section__first}>
            <Text style={styles.gray__text__heading}>Service Advisor:</Text>
            <Text style={styles.gray__small__text}>{serviceAdvisor?.name}</Text>
          </View>
        </View>

        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Mileage In:</Text>
          <Text style={styles.gray__small__text}>
            {mileageIn}{' '}
            {mileageInType === 'KPH'
              ? 'KM'
              : mileageInType === 'MPH'
              ? 'Miles'
              : ''}
          </Text>
          <View style={styles.section__first}>
            <Text style={styles.gray__text__heading}>
              Extras with Vehicle:{' '}
            </Text>
            {extrasWithVehicle?.split(',')?.map((ext, i) => (
              <Text key={i++} style={styles.gray__small__text}>
                {ext}
              </Text>
            ))}
          </View>
        </View>
      </View>
    </>
  );
}
